<template>
  <div class="TextTooltip-root" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <div ref="trigger" class="trigger ellipsis"><slot /></div>
    <portal to="MindsPopovers">
      <div v-if="showTooltip" :style="tooltipStyle" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave"><slot /></div>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'TextTooltip',
  data() {
    return {
      showTooltip: false,
      tooltipStyle: {},
      hovering: false,
      hideTimeout: null,
    }
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const trigger = this.$refs.trigger;
        const text = trigger?.querySelector('span');

        if (trigger && trigger.offsetWidth == text.offsetWidth) {
          const rect = text.getBoundingClientRect();
          this.tooltipStyle = { //Style is applied here since the tooltip is teleported outside the component's scope
            position: 'fixed',
            top: `${rect.top + (rect.height/2)}px`,
            transform: 'translate(0%, -50%)',
            left: `${rect.left -4}px`,
            padding: '0 4px',
            backgroundColor: 'white',
            zIndex: 9999,
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.25)'
          }
          this.showTooltip = true
        }
      })
    },
    onMouseEnter() {
      clearTimeout(this.hideTimeout);
      this.hovering = true;
      this.checkOverflow();
    },
    onMouseLeave() {
      this.hovering = false
      this.hideTimeout = setTimeout(() => {
        if (!this.hovering) {
          this.showTooltip = false
        }
      }, 100) // Small delay to avoid closing while the tooltip is still hovered
    }
  }
}
</script>

<style scoped lang="scss">
.v-application .text-end .trigger {
  justify-content: end;
}

.TextTooltip-root,
.TextTooltip-root .trigger {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
}

.ellipsis * {
  display: block;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
  padding: 2px 0; //Prevent text from being cropped at the top or bottom
}

</style>


<!-- DOCUMENTATION --

TextTooltip.vue

  Description:
  A wrapper component that shows a tooltip when the text is truncated (via ellipsis).
  The tooltip displays the full content on hover. 
  
  Note that since the tooltip is teleported (via <portal>), inherited styles like font-size or color won’t apply automatically.
  To preserve styling, pass global classes or inline style using a <span> inside the slot.

  Example:
  <TextTooltip>
    <span style="font-size: 0.75rem; font-weight: bold; color: #546975">{{ text }}</span>
  </TextTooltip>
-->